import type React from 'react';

import { TabList, Tabs } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

export const PageTabs: React.FC = () => {
	const { translate } = useI18n();
	return (
		<div className="container mb-4 px-0">
			<Tabs selectedKey="about">
				<TabList
					items={[
						{
							id: 'about',
							label: translate('fe.components.brand_pages_navbar.about'),
							href: '/about',
						},
						{
							id: 'impact',
							label: translate('fe.components.brand_pages_navbar.impact'),
							href: '/impact',
						},
						{
							id: 'careers',
							label: translate('fe.components.brand_pages_navbar.careers'),
							href: '/careers',
						},
						{
							id: 'team',
							label: translate('fe.components.brand_pages_navbar.team'),
							href: '/about/team',
						},
					]}
				/>
			</Tabs>
		</div>
	);
};
